<template>
  <div id="pageItemList">
    <page-header></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('fulltextSearch')"
                v-model="searchInput"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="users"
                :rows-per-page-items="[10, 25, 50]"
                :pagination.sync="pagination"
                :total-items="usersCount"
                :loading="isLoading"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.username }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ renderPermissions(props.item.roles) }}</td>
                  <td>{{ props.item.created_at | moment("LLL") }}</td>
                  <td>
                    <action-tooltip
                      icon="edit"
                      color="info"
                      :tooltip="$t('edit')"
                      @click="editAction(props.item.id)"
                    ></action-tooltip>
                    <action-tooltip
                      icon="delete"
                      color="red"
                      :tooltip="$t('delete')"
                      @click="$refs.deleteDialog.deleteAction(props.item)"
                    ></action-tooltip>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <users-create-edit-dialog
      v-model="modal"
      @saved="fetchItems"
    ></users-create-edit-dialog>

    <delete-dialog
      messageKey="deleteUserMessage"
      ref="deleteDialog"
      @confirm="deleteConfirmation"
    ></delete-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_USERS,
  FETCH_USER,
  DELETE_USER,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import PermissionsService from "../../common/permission.service";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import createButtonMixin from "@/mixins/createButton.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";
import paginationMixin from "@/mixins/pagination.mixin";
import UsersCreateEditDialog from "@/views/User/UsersCreateEditDialog.vue";

export default {
  components: {
    "users-create-edit-dialog": UsersCreateEditDialog
  },
  data() {
    return {
      modal: {
        show: false,
        mode: ""
      },
      headers: [
        { text: this.$t("username"), value: "username" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("permissions"), sortable: false },
        { text: this.$t("creationDate"), value: "created_at" },
        { text: this.$t("actions"), sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters(["users", "usersCount", "user", "isLoading"])
  },
  mixins: [
    refreshButtonMixin,
    createButtonMixin,
    searchInputMixin,
    paginationMixin
  ],
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_USERS, [this.pagination, this.search]);
    },
    createAction() {
      this.modal.mode = "create";
      this.modal.show = true;
    },
    editAction(id) {
      this.$store.dispatch(FETCH_USER, id).then(() => {
        this.modal.mode = "edit";
        this.modal.show = true;
      });
    },
    deleteConfirmation(user) {
      this.$store.dispatch(DELETE_USER, user.id).then(() => {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("deletedSuccessfully", [this.$t("user")]),
          color: "success"
        });

        this.fetchItems();
      });
    },
    renderPermissions(permissions) {
      return PermissionsService.getString(permissions);
    }
  }
};
</script>

<style scoped></style>
